import {
  Map,
  fromJS,
} from 'immutable'
import {
  SET_PM_SCREEN,
  SET_PM_SCREEN_PROCESSING,
  RESET_PM_SCREEN,
  DELETE_PM_SCREEN,
  SET_PM_SCREEN_ERROR,
} from './actions'

export const initialState = Map({})

/**
 * Page manager screen reducer
 */
export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SET_PM_SCREEN: {
      const {
        screenType, language, data, processing = false,
      } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([screenType, language, 'processing'], processing)
          .setIn([screenType, language, 'dataCreated'], new Date())
          .setIn([screenType, language, 'data'], fromJS(data))
          .deleteIn([screenType, language, 'error'])
          .deleteIn([screenType, language, 'errorCreated'])
        // Track processing
        if (processing) {
          mutableState
            .setIn([screenType, language, 'processingStarted'], new Date())
        } else {
          mutableState
            .setIn([screenType, language, 'processingEnded'], new Date())
        }
      })
    }
    case SET_PM_SCREEN_PROCESSING: {
      const { screenType, language, processing } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([screenType, language, 'processing'], processing)
        // Track processing
        if (processing) {
          mutableState
            .setIn([screenType, language, 'processingStarted'], new Date())
        } else {
          mutableState
            .setIn([screenType, language, 'processingEnded'], new Date())
        }
      })
    }
    case RESET_PM_SCREEN:
      return initialState
    case DELETE_PM_SCREEN: {
      const { screenType, language } = action.payload
      if (language) {
        return state.deleteIn([screenType, language])
      }
      return state.delete(screenType)
    }
    case SET_PM_SCREEN_ERROR: {
      const {
        screenType, language, error, processing = false,
      } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([screenType, language, 'processing'], false)
          .setIn([screenType, language, 'processingEnded'], new Date())
          .deleteIn([screenType, language, 'dataCreated'])
          .deleteIn([screenType, language, 'data'])
          .setIn([screenType, language, 'error'], error)
          .setIn([screenType, language, 'errorCreated'], new Date())
        // Track processing
        if (processing) {
          mutableState
            .setIn([screenType, language, 'processingStarted'], new Date())
        } else {
          mutableState
            .setIn([screenType, language, 'processingEnded'], new Date())
        }
      })
    }
    default:
      return state
  }
}
